<!-- <svg:svg [attr.x]="0" y="0" width="25" height="12.5" viewBox="0 0 100 50"> -->
<svg:svg
    class="toggle"
    [attr.x]="posX"
    [attr.y]="posY"
    width="100"
    height="50"
    viewBox="0 0 300 150"
>
    <svg:g (click)="onClick()">
        <svg:path
            fill="#0057ff"
            d="M 25 0 h 50 A 25 25 0 1 1 75 50 h -50 M 25 0 A 25 25 0 1 0 25 50 z"
        />
        <svg:circle fill="#ffffff" cx="25" cy="25" r="20" />
    </svg:g>
</svg:svg>
<svg:svg [attr.x]="posX + 25" [attr.y]="posY" height="25">
    <svg:text x="12.5" y="12.5">{{ label }}</svg:text>
</svg:svg>
